export const version = '200106-9324877';



// WEBPACK FOOTER //
// ./src/version.js